import { Typography } from '@gds/Typography/Typography';
import { RichText } from '@page-builder/Components/RichText/RichText';

import styles from './CampaignPromotionModal.module.css';

export const CampaignPromotionModal = (campaignData: Record<string, any>) => {
  const {
    campaignData: { title, description },
  } = campaignData;

  return (
    <section className={styles.wrapper}>
      <header>
        <Typography Component="h1" variant="h3">
          {title?.value}
        </Typography>
      </header>
      <div className={styles.modalBody}>
        <RichText richText={description?.value} />
      </div>
    </section>
  );
};
